import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITransaction } from "pages/Finance";

export interface FinanceState {
  balance: number;
  currency: string;
  transactions: { items: ITransaction[]; loaded: boolean };
}

const initialState: FinanceState = {
  balance: 0,
  currency: "GBP",
  transactions: { loaded: false, items: [] },
};

export const financeSlice = createSlice({
  name: "finance",
  initialState,
  reducers: {
    fetchBalance(
      state,
      action: PayloadAction<{ balance: number; currency: string }>,
    ) {
      Object.assign(state, action.payload);
    },
    fetchTransactions(state, action: PayloadAction<ITransaction[]>) {
      state.transactions.items = action.payload;
      state.transactions.loaded = true;
    },
  },
});

export const { fetchBalance, fetchTransactions } = financeSlice.actions;
export default financeSlice.reducer;
